import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import ObiHubOsLayout from "./ObiHubOsLayout";
import { parseUiCapabilities } from "./uiCapabilities";

export default function PanelLayoutGate() {
  const { user } = useAuth();
  const [decision, setDecision] = useState({ status: "loading", capability: null });

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setDecision({ status: "loading", capability: null });
    (async () => {
      try {
        const raw = await api.get("/ui-capabilities", { no_retry: true, retry_attempts: 1, signal: controller.signal });
        const parsed = parseUiCapabilities(raw);
        if (active) setDecision(parsed?.enabled ? { status: "os", capability: parsed } : { status: "legacy", capability: null });
      } catch {
        if (active) setDecision({ status: "legacy", capability: null });
      }
    })();
    return () => { active = false; controller.abort(); };
  }, [user?.id]);

  // Default-OFF kullanıcılar eski kabuğu capability cevabını beklemeden görür;
  // endpoint gecikmesi mevcut paneli tam ekran beklemeye çeviremez.
  if (decision.status === "loading") return <DashboardLayout />;
  if (decision.status !== "os") return <DashboardLayout />;
  return <ObiHubOsLayout capability={decision.capability} />;
}
